import type { CrudQuery, PaginationResponse } from "shared-components";

import { actionHandler } from "@/api/action-handler";
import { clientGet, clientPost } from "@/api/client";

import type { RootTheme, SubTheme } from "./models";

export const getRootThemesList = actionHandler(
  async (): Promise<{ data?: RootTheme[]; error?: { message: string } }> => {
    return clientGet({ path: "theme/root" });
  },
);

export const getSubthemesListFromRoot = actionHandler(
  async ({ id, ...payload }: CrudQuery & { id: string }): Promise<PaginationResponse<SubTheme>> => {
    return clientPost({ path: `theme/${id}/search`, payload });
  },
);

export const getSubthemesList = actionHandler(async (payload: CrudQuery): Promise<PaginationResponse<SubTheme>> => {
  return clientPost({ path: "theme/search", payload });
});
